import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=08dffec3&scoped=true&"
import script from "./Configuration.vue?vue&type=script&lang=ts&"
export * from "./Configuration.vue?vue&type=script&lang=ts&"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=08dffec3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dffec3",
  null
  
)

export default component.exports